import React from 'react';
import PropTypes from 'prop-types';

import Feedback from '@xingternal/malt-feedback';

import ErrorContext from './ErrorContext';

const ErrorMessage = ({ onClick }) => (
  <ErrorContext.Consumer>
    {({ message, show }) => (
      <Feedback show={show} onCancel={onClick}>
        {message}
      </Feedback>
    )}
  </ErrorContext.Consumer>
);

ErrorMessage.propTypes = {
  onClick: PropTypes.func,
};

export default ErrorMessage;
